import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/data/categories';
import { MAIN_SITE_URL, ARTICLE_SLUG } from '@/data/site';
import { isSupportedLanguage } from '@/data/languages';

export default function Footer() {
  const { t } = useTranslation();
  const location = useLocation();
  const firstSegment = location.pathname.split('/').filter(Boolean)[0];
  const lang = isSupportedLanguage(firstSegment) ? firstSegment : 'en';

  return (
    <footer className="mt-16 bg-primary-950 text-background-50">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-table-2 text-lg leading-none text-white"></i>
              </span>
              <span className="whitespace-nowrap font-heading text-lg font-semibold">{t('brand')}</span>
            </div>
            <p className="mt-4 max-w-xs text-sm text-primary-100/90">{t('footer.tagline')}</p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white">{t('footer.categoriesTitle')}</h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-6 gap-y-2">
              {categories.map((category) => (
                <li key={category.key}>
                  <a
                    href={category.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="whitespace-nowrap text-sm text-primary-100/80 transition-colors hover:text-white"
                  >
                    {t(category.key)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white">{t('footer.resourcesTitle')}</h4>
            <ul className="mt-4 flex flex-col gap-2">
              <li>
                <Link
                  to={`/${lang}/${ARTICLE_SLUG}`}
                  className="whitespace-nowrap text-sm text-primary-100/80 transition-colors hover:text-white"
                >
                  {t('footer.guideLink')}
                </Link>
              </li>
              <li>
                <a
                  href={MAIN_SITE_URL}
                  target="_blank"
                  rel="noopener nofollow"
                  className="whitespace-nowrap text-sm text-primary-100/80 transition-colors hover:text-white"
                >
                  {t('footer.mainSiteLink')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-primary-800 pt-6">
          <p className="text-xs text-primary-100/70">{t('footer.disclaimer')}</p>
          <p className="mt-3 text-xs text-primary-100/60">
            © {new Date().getFullYear()} {t('brand')}. {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  );
}